import {environment} from '../../environments/environment';

/**
 * Resolve the API base URL at runtime (Story 27.9).
 *
 * Deployed (any non-localhost host) → the current page origin, so the SPA stays
 * same-origin on BOTH the platform host (`auth.<env>.emjo-consulting.dk`) and a
 * tenant's custom domain. Host-consolidation (Stories 27.1/27.5) put the SPA and
 * the API behind the same CloudFront distribution, and the custom-domain
 * distribution tenant routes the same end-user API paths to the API origin
 * (`custom_domain_api_path_patterns`), so the current origin is always correct
 * when deployed.
 *
 * Local `ng serve` (`localhost:4200`) and karma (`localhost:9876`) have no
 * co-located API, so they fall back to the configured `environment.authUrl`
 * (the remote dev/stage/prod API). This fallback also keeps the existing specs
 * green unchanged — under karma `resolveApiBase()` === `environment.authUrl`.
 */
export function resolveApiBase(): string {
  const {hostname, origin} = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return environment.authUrl;
  }
  return origin;
}
